import { render, staticRenderFns } from "./DepartmentListUserFilter.vue?vue&type=template&id=5021f408&scoped=true&"
import script from "./DepartmentListUserFilter.vue?vue&type=script&lang=ts&"
export * from "./DepartmentListUserFilter.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentListUserFilter.vue?vue&type=style&index=0&id=5021f408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5021f408",
  null
  
)

export default component.exports